import { useDistributions, useTargets } from '@/api/hooks.js';
import { DistributionList } from '@/components/DistributionList.js';
import { ExperienceTabs } from '@/components/ExperienceTabs.js';
import { EmptyState, ErrorNotice, Loading } from '@/components/ui.js';

/**
 * Everything this workspace has sent, newest first.
 *
 * Scoped to the tenant rather than the signed-in user: creatives are a shared
 * asset, and "has this project already gone to Google Ads?" is the question
 * being asked here, which a per-user view would answer wrongly.
 */
export function DistributionsPage() {
  const distributions = useDistributions();
  // Deactivated targets included, so runs against a removed destination still
  // show which account they landed in.
  const targets = useTargets(true);

  return (
    <div>
      <ExperienceTabs />

      <p className="mb-6 max-w-xl text-sm text-muted">
        Creatives sent to your channels, newest first. Open one to see how each layout fared.
      </p>

      {distributions.isLoading ? <Loading label="Loading distributions…" /> : null}
      {distributions.error ? <ErrorNotice error={distributions.error} /> : null}

      {distributions.data && distributions.data.distributions.length === 0 ? (
        <EmptyState
          title="Nothing sent yet"
          description="Pick a project and distribute its layouts to see the results here."
        />
      ) : null}

      {distributions.data && distributions.data.distributions.length > 0 ? (
        <DistributionList
          distributions={distributions.data.distributions}
          targets={targets.data?.targets ?? []}
          linkBase="/experience/distributions"
        />
      ) : null}
    </div>
  );
}
